import { useMemo, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';

import { FHPagination } from '../../base';
import CardSkeletonLoader from './CardSkeletonLoader';
import SessionNoteItem from './SessionNoteItem';

import type { ISessionMinified } from '../../../utils/types';

const SlideChunkSize = 4;

interface EditsRequestedSessionNotesProps {
  sessions: ISessionMinified[];
  loading: boolean;
}

function EditsRequestedSessionNotes(props: EditsRequestedSessionNotesProps) {
  const { sessions, loading } = props;
  const [currentPage, setCurrentPage] = useState(1);

  const chunkedArray = useMemo(() => {
    if (!sessions) return [];

    const group = [];
    for (let i = 0; i < sessions.length; i += SlideChunkSize) {
      group.push(sessions.slice(i, i + SlideChunkSize));
    }
    return group;
  }, [sessions]);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      {loading ? (
        <Grid container spacing={{ xs: 0.5, sm: 2, md: 2 }}>
          {[...Array(SlideChunkSize)].map((_, index) => (
            <Grid key={index} item xs={12} sm={6} md={4} lg={3} mb={1}>
              <CardSkeletonLoader />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid container spacing={{ xs: 0.5, sm: 2, md: 2 }}>
          {sessions.length > 0 ? (
            chunkedArray[currentPage - 1]?.map((session) => (
              <Grid key={session.id} item xs={12} sm={6} md={4} lg={3} mb={1}>
                <SessionNoteItem session={session} reviewItem />
              </Grid>
            ))
          ) : (
            <Box sx={{ display: 'flex', marginTop: '8px' }}>
              <Typography mt={2} ml={2}>
                There are no session notes&apos; reviews to display.
              </Typography>
            </Box>
          )}
        </Grid>
      )}
      {chunkedArray.length > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <FHPagination
            count={chunkedArray.length}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        </Box>
      )}
    </Box>
  );
}

export default EditsRequestedSessionNotes;
